export const GET_PROFILE_REQUEST = "GET_PROFILE_REQUEST";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_FAIL = "GET_PROFILE_FAIL";

export const GET_PROFILES_REQUEST = "GET_PROFILES_REQUEST";
export const GET_PROFILES_SUCCESS = "GET_PROFILES_SUCCESS";
export const GET_PROFILES_FAIL = "GET_PROFILES_FAIL";

export const GET_PROFILE_BYID_REQUEST = "GET_PROFILE_BYID_REQUEST";
export const GET_PROFILE_BYID_SUCCESS = "GET_PROFILE_BYID_SUCCESS";
export const GET_PROFILE_BYID_FAIL = "GET_PROFILE_BYID_FAIL";

export const CLEAR_PROFILE = "CLEAR_PROFILE";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const PROFILE_NOT_FOUND = "PROFILE_NOT_FOUND";
export const CLEAR_CURRENT_PROFILE = "CLEAR_CURRENT_PROFILE";
export const ACCOUNT_DELETE = "ACCOUNT_DELETE";
export const ACCOUNT_DELETE_FAIL = "ACCOUNT_DELETE_FAIL";
